export function validateRequest(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const format0 = new RegExp(
      '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$',
      'i',
    )
    const pattern0 = new RegExp('^.*$', 'u')
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format1 = new RegExp('^[A-Z0-9_-]+\\.[A-Z0-9_-]+\\.[A-Z0-9_-]*$', 'i')
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('jsonrpc' in data && hasOwn(data, 'jsonrpc'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/jsonrpc' },
        ]
        return false
      }
      if (!('id' in data && hasOwn(data, 'id'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/id' },
        ]
        return false
      }
      if (!('method' in data && hasOwn(data, 'method'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/method' },
        ]
        return false
      }
      if (!(data.jsonrpc === '2.0')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/jsonrpc/const',
            instanceLocation: '#/jsonrpc',
          },
        ]
        return false
      }
      let passes0 = 0
      const sub0 = (() => {
        if (!(typeof data.id === 'string')) return false
        if (!format0.test(data.id)) return false
        return true
      })()
      if (sub0) passes0++
      const sub1 = (() => {
        if (!Number.isInteger(data.id)) return false
        return true
      })()
      if (sub1) passes0++
      if (passes0 !== 1) {
        validate.errors = [
          {
            keywordLocation: '#/properties/id/oneOf',
            instanceLocation: '#/id',
          },
        ]
        return false
      }
      if (!(typeof data.method === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/type',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      if (!pattern0.test(data.method)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/pattern',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      switch (data.method) {
        case 'bitcoin_standard_connect':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!Array.isArray(data.params)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/properties/params/type',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (0 in data.params && hasOwn(data.params, 0)) {
            if (
              !(
                typeof data.params[0] === 'object' &&
                data.params[0] &&
                !Array.isArray(data.params[0])
              )
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/0/properties/params/0/type',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (
              !(
                'purposes' in data.params[0] &&
                hasOwn(data.params[0], 'purposes')
              )
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/0/properties/params/0/required',
                  instanceLocation: '#/params/0/purposes',
                },
              ]
              return false
            }
            if (!Array.isArray(data.params[0].purposes)) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/oneOf/0/properties/params/0/properties/purposes/type',
                  instanceLocation: '#/params/0/purposes',
                },
              ]
              return false
            }
            for (let i = 0; i < data.params[0].purposes.length; i++) {
              if (
                i in data.params[0].purposes &&
                hasOwn(data.params[0].purposes, i)
              ) {
                if (
                  !(
                    data.params[0].purposes[i] === 'payment' ||
                    data.params[0].purposes[i] === 'ordinals'
                  )
                ) {
                  validate.errors = [
                    {
                      keywordLocation:
                        '#/oneOf/0/properties/params/0/properties/purposes/items/enum',
                      instanceLocation: '#/params/purposes/' + i,
                    },
                  ]
                  return false
                }
              }
            }
            for (const key0 of Object.keys(data.params[0])) {
              if (key0 !== 'purposes') {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/oneOf/0/properties/params/0/unevaluatedProperties',
                    instanceLocation: '#/params/' + pointerPart(key0),
                  },
                ]
                return false
              }
            }
          }
          if (data.params.length > 1) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/properties/params/items',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'bitcoin_connect':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!Array.isArray(data.params)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/properties/params/type',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (0 in data.params && hasOwn(data.params, 0)) {
            if (!(typeof data.params[0] === 'string')) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/1/properties/params/0/type',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (
              data.params[0].length > 4194304 &&
              stringLength(data.params[0]) > 4194304
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/1/properties/params/0/maxLength',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (!format1.test(data.params[0])) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/1/properties/params/0/format',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
          }
          if (data.params.length > 1) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/properties/params/items',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'bitcoin_signTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!Array.isArray(data.params)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/properties/params/type',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (0 in data.params && hasOwn(data.params, 0)) {
            if (!(typeof data.params[0] === 'string')) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/2/properties/params/0/type',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (
              data.params[0].length > 4194304 &&
              stringLength(data.params[0]) > 4194304
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/2/properties/params/0/maxLength',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (!format1.test(data.params[0])) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/2/properties/params/0/format',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
          }
          if (data.params.length > 1) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/properties/params/items',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'bitcoin_sendBtcTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!Array.isArray(data.params)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/properties/params/type',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (0 in data.params && hasOwn(data.params, 0)) {
            if (!(typeof data.params[0] === 'string')) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/3/properties/params/0/type',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (
              data.params[0].length > 4194304 &&
              stringLength(data.params[0]) > 4194304
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/3/properties/params/0/maxLength',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (!format1.test(data.params[0])) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/3/properties/params/0/format',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
          }
          if (data.params.length > 1) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/properties/params/items',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'bitcoin_signMessage':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/4/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!Array.isArray(data.params)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/4/properties/params/type',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (0 in data.params && hasOwn(data.params, 0)) {
            if (!(typeof data.params[0] === 'string')) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/4/properties/params/0/type',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (
              data.params[0].length > 4194304 &&
              stringLength(data.params[0]) > 4194304
            ) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/4/properties/params/0/maxLength',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
            if (!format1.test(data.params[0])) {
              validate.errors = [
                {
                  keywordLocation: '#/oneOf/4/properties/params/0/format',
                  instanceLocation: '#/params/0',
                },
              ]
              return false
            }
          }
          if (data.params.length > 1) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/4/properties/params/items',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'bitcoin_isConnected':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/5/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/5/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        default:
          validate.errors = [
            { keywordLocation: '#/oneOf', instanceLocation: '#' },
          ]
          return false
      }
      for (const key1 of Object.keys(data)) {
        if (
          key1 !== 'id' &&
          key1 !== 'jsonrpc' &&
          key1 !== 'method' &&
          key1 !== 'params'
        ) {
          validate.errors = [
            {
              keywordLocation: '#/unevaluatedProperties',
              instanceLocation: '#/' + pointerPart(key1),
            },
          ]
          return false
        }
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}

export function validateGetAddressOptions(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const ref1 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      for (let i = 0; i < data.length; i++) {
        if (i in data && hasOwn(data, i)) {
          if (!(data[i] === 'payment' || data[i] === 'ordinals')) {
            validate.errors = [
              { keywordLocation: '#/items/enum', instanceLocation: '#/' + i },
            ]
            return false
          }
        }
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format0 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const ref2 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('type' in data && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!(data.type === 'Mainnet' || data.type === 'Testnet')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/enum',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      for (const key0 of Object.keys(data)) {
        if (key0 !== 'type') delete data[key0]
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if ('purposes' in data && hasOwn(data, 'purposes')) {
        const err0 = validate.errors
        const res0 = ref1(data.purposes)
        const suberr0 = ref1.errors
        validate.errors = err0
        if (!res0) {
          validate.errors = [
            errorMerge(suberr0[0], '#/properties/purposes/$ref', '#/purposes'),
          ]
          return false
        }
      }
      if ('message' in data && hasOwn(data, 'message')) {
        if (!(typeof data.message === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/type',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
        if (data.message.length > 100 && stringLength(data.message) > 100) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/maxLength',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
        if (!format0.test(data.message)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/format',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
      }
      if ('network' in data && hasOwn(data, 'network')) {
        const err1 = validate.errors
        const res1 = ref2(data.network)
        const suberr1 = ref2.errors
        validate.errors = err1
        if (!res1) {
          validate.errors = [
            errorMerge(suberr1[0], '#/properties/network/$ref', '#/network'),
          ]
          return false
        }
      }
      for (const key1 of Object.keys(data)) {
        if (key1 !== 'purposes' && key1 !== 'message' && key1 !== 'network')
          delete data[key1]
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}

export function validateSignTransactionOptions(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format0 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const format1 = (input) => /^[a-z0-9+/]*={0,3}$/i.test(input)
    const format2 = new RegExp('^[a-zA-Z0-9]+$', '')
    const ref1 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'string')) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length > 62 && stringLength(data) > 62) {
        validate.errors = [
          { keywordLocation: '#/maxLength', instanceLocation: '#' },
        ]
        return false
      }
      if (!format2.test(data)) {
        validate.errors = [
          { keywordLocation: '#/format', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const ref2 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('type' in data && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!(data.type === 'Mainnet' || data.type === 'Testnet')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/enum',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      for (const key1 of Object.keys(data)) {
        if (key1 !== 'type') delete data[key1]
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('psbtBase64' in data && hasOwn(data, 'psbtBase64'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/psbtBase64' },
        ]
        return false
      }
      if (!('inputsToSign' in data && hasOwn(data, 'inputsToSign'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/inputsToSign' },
        ]
        return false
      }
      if ('message' in data && hasOwn(data, 'message')) {
        if (!(typeof data.message === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/type',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
        if (data.message.length > 100 && stringLength(data.message) > 100) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/maxLength',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
        if (!format0.test(data.message)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/format',
              instanceLocation: '#/message',
            },
          ]
          return false
        }
      }
      if (!(typeof data.psbtBase64 === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/psbtBase64/type',
            instanceLocation: '#/psbtBase64',
          },
        ]
        return false
      }
      if (!format1(data.psbtBase64)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/psbtBase64/format',
            instanceLocation: '#/psbtBase64',
          },
        ]
        return false
      }
      if (!Array.isArray(data.inputsToSign)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/inputsToSign/type',
            instanceLocation: '#/inputsToSign',
          },
        ]
        return false
      }
      for (let i = 0; i < data.inputsToSign.length; i++) {
        if (i in data.inputsToSign && hasOwn(data.inputsToSign, i)) {
          if (
            !(
              typeof data.inputsToSign[i] === 'object' &&
              data.inputsToSign[i] &&
              !Array.isArray(data.inputsToSign[i])
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/inputsToSign/items/type',
                instanceLocation: '#/inputsToSign/' + i,
              },
            ]
            return false
          }
          if (
            !(
              'address' in data.inputsToSign[i] &&
              hasOwn(data.inputsToSign[i], 'address')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/inputsToSign/items/required',
                instanceLocation: '#/inputsToSign/' + i + '/address',
              },
            ]
            return false
          }
          if (
            !(
              'signingIndexes' in data.inputsToSign[i] &&
              hasOwn(data.inputsToSign[i], 'signingIndexes')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/inputsToSign/items/required',
                instanceLocation: '#/inputsToSign/' + i + '/signingIndexes',
              },
            ]
            return false
          }
          const err0 = validate.errors
          const res0 = ref1(data.inputsToSign[i].address)
          const suberr0 = ref1.errors
          validate.errors = err0
          if (!res0) {
            validate.errors = [
              errorMerge(
                suberr0[0],
                '#/properties/inputsToSign/items/properties/address/$ref',
                '#/inputsToSign/' + i + '/address',
              ),
            ]
            return false
          }
          if (!Array.isArray(data.inputsToSign[i].signingIndexes)) {
            validate.errors = [
              {
                keywordLocation:
                  '#/properties/inputsToSign/items/properties/signingIndexes/type',
                instanceLocation: '#/inputsToSign/' + i + '/signingIndexes',
              },
            ]
            return false
          }
          for (let j = 0; j < data.inputsToSign[i].signingIndexes.length; j++) {
            if (
              j in data.inputsToSign[i].signingIndexes &&
              hasOwn(data.inputsToSign[i].signingIndexes, j)
            ) {
              if (
                !(typeof data.inputsToSign[i].signingIndexes[j] === 'number')
              ) {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/properties/inputsToSign/items/properties/signingIndexes/items/type',
                    instanceLocation:
                      '#/inputsToSign/' + i + 'signingIndexes/' + j,
                  },
                ]
                return false
              }
              if (!(0 <= data.inputsToSign[i].signingIndexes[j])) {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/properties/inputsToSign/items/properties/signingIndexes/items/minimum',
                    instanceLocation:
                      '#/inputsToSign/' + i + 'signingIndexes/' + j,
                  },
                ]
                return false
              }
            }
          }
          if (
            'sigHash' in data.inputsToSign[i] &&
            hasOwn(data.inputsToSign[i], 'sigHash')
          ) {
            if (!(typeof data.inputsToSign[i].sigHash === 'number')) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/properties/inputsToSign/items/properties/sigHash/type',
                  instanceLocation: '#/inputsToSign/' + i + '/sigHash',
                },
              ]
              return false
            }
            if (!(0 <= data.inputsToSign[i].sigHash)) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/properties/inputsToSign/items/properties/sigHash/minimum',
                  instanceLocation: '#/inputsToSign/' + i + '/sigHash',
                },
              ]
              return false
            }
          }
          for (const key0 of Object.keys(data.inputsToSign[i])) {
            if (
              key0 !== 'address' &&
              key0 !== 'sigHash' &&
              key0 !== 'signingIndexes'
            ) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/properties/inputsToSign/items/unevaluatedProperties',
                  instanceLocation:
                    '#/inputsToSign/' + i + '/' + pointerPart(key0),
                },
              ]
              return false
            }
          }
        }
      }
      if ('network' in data && hasOwn(data, 'network')) {
        const err1 = validate.errors
        const res1 = ref2(data.network)
        const suberr1 = ref2.errors
        validate.errors = err1
        if (!res1) {
          validate.errors = [
            errorMerge(suberr1[0], '#/properties/network/$ref', '#/network'),
          ]
          return false
        }
      }
      if ('broadcast' in data && hasOwn(data, 'broadcast')) {
        if (!(typeof data.broadcast === 'boolean')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/broadcast/type',
              instanceLocation: '#/broadcast',
            },
          ]
          return false
        }
      }
      for (const key2 of Object.keys(data)) {
        if (
          key2 !== 'message' &&
          key2 !== 'psbtBase64' &&
          key2 !== 'inputsToSign' &&
          key2 !== 'network' &&
          key2 !== 'broadcast'
        )
          delete data[key2]
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}

export function validateSendBtcTransactionOptions(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format0 = new RegExp('^[a-zA-Z0-9]+$', '')
    const ref1 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'string')) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length > 62 && stringLength(data) > 62) {
        validate.errors = [
          { keywordLocation: '#/maxLength', instanceLocation: '#' },
        ]
        return false
      }
      if (!format0.test(data)) {
        validate.errors = [
          { keywordLocation: '#/format', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const format1 = new RegExp('^[\\d]+$', 'i')
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const ref2 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('type' in data && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!(data.type === 'Mainnet' || data.type === 'Testnet')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/enum',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      for (const key1 of Object.keys(data)) {
        if (key1 !== 'type') delete data[key1]
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('recipients' in data && hasOwn(data, 'recipients'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/recipients' },
        ]
        return false
      }
      if (!('senderAddress' in data && hasOwn(data, 'senderAddress'))) {
        validate.errors = [
          {
            keywordLocation: '#/required',
            instanceLocation: '#/senderAddress',
          },
        ]
        return false
      }
      const err0 = validate.errors
      const res0 = ref1(data.senderAddress)
      const suberr0 = ref1.errors
      validate.errors = err0
      if (!res0) {
        validate.errors = [
          errorMerge(
            suberr0[0],
            '#/properties/senderAddress/$ref',
            '#/senderAddress',
          ),
        ]
        return false
      }
      if (!Array.isArray(data.recipients)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/recipients/type',
            instanceLocation: '#/recipients',
          },
        ]
        return false
      }
      for (let i = 0; i < data.recipients.length; i++) {
        if (i in data.recipients && hasOwn(data.recipients, i)) {
          if (
            !(
              typeof data.recipients[i] === 'object' &&
              data.recipients[i] &&
              !Array.isArray(data.recipients[i])
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/recipients/items/type',
                instanceLocation: '#/recipients/' + i,
              },
            ]
            return false
          }
          if (
            !(
              'address' in data.recipients[i] &&
              hasOwn(data.recipients[i], 'address')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/recipients/items/required',
                instanceLocation: '#/recipients/' + i + '/address',
              },
            ]
            return false
          }
          if (
            !(
              'amountSats' in data.recipients[i] &&
              hasOwn(data.recipients[i], 'amountSats')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/properties/recipients/items/required',
                instanceLocation: '#/recipients/' + i + '/amountSats',
              },
            ]
            return false
          }
          const err1 = validate.errors
          const res1 = ref1(data.recipients[i].address)
          const suberr1 = ref1.errors
          validate.errors = err1
          if (!res1) {
            validate.errors = [
              errorMerge(
                suberr1[0],
                '#/properties/recipients/items/properties/address/$ref',
                '#/recipients/' + i + '/address',
              ),
            ]
            return false
          }
          if (!(typeof data.recipients[i].amountSats === 'string')) {
            validate.errors = [
              {
                keywordLocation:
                  '#/properties/recipients/items/properties/amountSats/type',
                instanceLocation: '#/recipients/' + i + '/amountSats',
              },
            ]
            return false
          }
          if (
            data.recipients[i].amountSats.length > 16 &&
            stringLength(data.recipients[i].amountSats) > 16
          ) {
            validate.errors = [
              {
                keywordLocation:
                  '#/properties/recipients/items/properties/amountSats/maxLength',
                instanceLocation: '#/recipients/' + i + '/amountSats',
              },
            ]
            return false
          }
          if (!format1.test(data.recipients[i].amountSats)) {
            validate.errors = [
              {
                keywordLocation:
                  '#/properties/recipients/items/properties/amountSats/format',
                instanceLocation: '#/recipients/' + i + '/amountSats',
              },
            ]
            return false
          }
          for (const key0 of Object.keys(data.recipients[i])) {
            if (key0 !== 'address' && key0 !== 'amountSats') {
              validate.errors = [
                {
                  keywordLocation:
                    '#/properties/recipients/items/unevaluatedProperties',
                  instanceLocation:
                    '#/recipients/' + i + '/' + pointerPart(key0),
                },
              ]
              return false
            }
          }
        }
      }
      if ('network' in data && hasOwn(data, 'network')) {
        const err2 = validate.errors
        const res2 = ref2(data.network)
        const suberr2 = ref2.errors
        validate.errors = err2
        if (!res2) {
          validate.errors = [
            errorMerge(suberr2[0], '#/properties/network/$ref', '#/network'),
          ]
          return false
        }
      }
      for (const key2 of Object.keys(data)) {
        if (
          key2 !== 'senderAddress' &&
          key2 !== 'recipients' &&
          key2 !== 'network'
        )
          delete data[key2]
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}

export function validateSignMessageOptions(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const format0 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const ref1 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('type' in data && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!(data.type === 'Mainnet' || data.type === 'Testnet')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/enum',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      for (const key0 of Object.keys(data)) {
        if (key0 !== 'type') delete data[key0]
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const format1 = new RegExp('^[a-zA-Z0-9]+$', '')
    const ref2 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'string')) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length > 62 && stringLength(data) > 62) {
        validate.errors = [
          { keywordLocation: '#/maxLength', instanceLocation: '#' },
        ]
        return false
      }
      if (!format1.test(data)) {
        validate.errors = [
          { keywordLocation: '#/format', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('address' in data && hasOwn(data, 'address'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/address' },
        ]
        return false
      }
      if (!('message' in data && hasOwn(data, 'message'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/message' },
        ]
        return false
      }
      if (!(typeof data.message === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/message/type',
            instanceLocation: '#/message',
          },
        ]
        return false
      }
      if (data.message.length > 10000 && stringLength(data.message) > 10000) {
        validate.errors = [
          {
            keywordLocation: '#/properties/message/maxLength',
            instanceLocation: '#/message',
          },
        ]
        return false
      }
      if (!format0.test(data.message)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/message/format',
            instanceLocation: '#/message',
          },
        ]
        return false
      }
      if ('network' in data && hasOwn(data, 'network')) {
        const err0 = validate.errors
        const res0 = ref1(data.network)
        const suberr0 = ref1.errors
        validate.errors = err0
        if (!res0) {
          validate.errors = [
            errorMerge(suberr0[0], '#/properties/network/$ref', '#/network'),
          ]
          return false
        }
      }
      const err1 = validate.errors
      const res1 = ref2(data.address)
      const suberr1 = ref2.errors
      validate.errors = err1
      if (!res1) {
        validate.errors = [
          errorMerge(suberr1[0], '#/properties/address/$ref', '#/address'),
        ]
        return false
      }
      for (const key1 of Object.keys(data)) {
        if (key1 !== 'message' && key1 !== 'network' && key1 !== 'address')
          delete data[key1]
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}
